module.exports = __webpack_public_path__ + "img/icn_app.fba11965.svg";